import styled from 'styled-components';

type WrapperProps = {
  width?: string;
};

export const Wrapper = styled.div<WrapperProps>`
  width: ${({ width }) => width ?? '100%'};
`;

export const BrandIcon = styled.img`
  width: 22px;
  height: 14px;
  object-fit: contain;
`;
